import React, {Component} from 'react';
import NavBarKS from "../../components/NavBarKS";
import moment from "moment";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';



class VersionTrack extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {


        const leftRender = date => {
            const momentDate = moment(date);
            return <div className="rc-timeline-date">
                <div>{momentDate.format('DD MMM')}</div>
                <div>{momentDate.format('HH:mm A')}</div>
            </div>
        };

        const rightRender = item => {
            return <div>
                <div className="rc-timeline-title">{item.title}</div>
                <div className="rc-timeline-body">{item.body}</div>
            </div>
        };

        return (
            <div className="row baseBackground">
                <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
                </NavBarKS>
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Sürüm Notları</h4>
                    </div>
                </div>

                <div>
                    <VerticalTimeline>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                            contentArrowStyle={{ borderRight: '5px solid  rgb(33, 150, 243)' }}
                            date="7 01.09.2021 – 30.11.2021"
                            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        >
                            <h3 className="vertical-timeline-element-title">V2.7 Sürüm Güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">İade faturaları, Ettn düzenlemesi.</h4>
                            <p>
                                Sistemde aynı mükellefe ait aynı doküman numarası ile birden fazla doküman kaydedilmesine izin verildi.
                                İade faturaları için eczacı depoları ile entegrasyon sağlandı
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            date="01.05.2021 – 30.08.2021"
                            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        >
                            <h3 className="vertical-timeline-element-title">V2.6 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">E-Arşiv rapor, Geçmişe dönük listeleme</h4>
                            <p>
                                e-Arşiv Raporları günlük olarak imzalanarak GİB e gönderimi düzenlendi.
                                Fatura listeleme sayfasında eski yıllara ait faturaların görüntüleme eklenildi.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            date="01.01.2021 – 30.04.2021"
                            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        >
                            <h3 className="vertical-timeline-element-title">V2.5 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">Fatura listeleme, Bug fix</h4>
                            <p>
                                Her kullanıcın sadece kendi firması tarafından oluşturulan faturaları görüntüleyebilmesi
                                kısıtı eklendi.
                                Excel listesinden taslak fatura oluştururken karşılaşılan hata giderildi.
                            </p>

                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            date="01.09.2020 – 30.12.2020"
                            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        >
                            <h3 className="vertical-timeline-element-title">V2.4 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">GİB şema ve şematron kontrolü</h4>
                            <p>
                                Gelen ve gönderilen tüm dokümanların GİB tarafından yayınlanan güncel şema ve
                                şematron (schematron) kontrolünden geçmesi sağlandı.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            date="01.05.2020 – 30.08.2020"
                            iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                        >
                            <h3 className="vertical-timeline-element-title">V2.3 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">E-mail gönderimi, Pdf oluşturma</h4>
                            <p>
                                Gönderilen E-Dönüşüm dokümanlarının mail olarak alıcısına iletilmesi sağlandı.
                                SGK faturaları için PDF okumanın eklendi.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            date="01.01.2020 – 30.04.2020"
                            iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                        >
                            <h3 className="vertical-timeline-element-title">V2.2 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">Loglama ve Web servisler</h4>
                            <p>
                                Kullanıcıların yaptığı tüm işlemlerin kayıtları kayda alındı. Kullanıcıların yaptığı tüm
                                işlemleri içeren kayıtların değişmezliği sağlandı.
                                GİB’inentegrasyon için sağlamış olduğu web-servisler ile entegre olabilecek yazılım ve donanaım alt yapısına sahip oldu.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            date="01.09.2019 – 30.12.2019"
                            iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                        >
                            <h3 className="vertical-timeline-element-title">V2.1 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">İmza kontrolü</h4>
                            <p>
                                İmzalanan dokümanlar imzalanırken imza sertifikasının geçerlilik süreleriyle CRL ve OCSP sonuçları kontrol edildi.
                                Hatalı XSLT olduğunda PDF alındı.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            date="01.06.2019 – 30.08.2019"
                            iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                        >
                            <h3 className="vertical-timeline-element-title">V2.0 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">Hakediş ve Endüstiyel şifreleme</h4>
                            <p>
                                Müşterilere endüstriyel şifreleme politikası zorunlu tutuldu.
                                Kontör durumunu izleme için hakkediş sayfasının oluştu.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                            date="01.02.2019 – 30.05.2019"
                        >
                            <h3 className="vertical-timeline-element-title">V1.9 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">Müşteri XML'i eklendi.</h4>
                            <p>
                                Hizmetini sonlandıran müşteriler için gelen ve giden dokümanların XML hali toplu olarak müşteriye iletildi.
                                Listeleme sayfalarında Türkçe karakter ile arama yapılandı.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                            date="01.10.2018-20.01.2019"
                        >
                            <h3 className="vertical-timeline-element-title">V1.8 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">E-Arşiv raporu, Web servisler</h4>
                            <p>
                                Verilen E-Dönüşüm hizmetleri ile ilgili web-service altyapısı sağlandı.
                                Gönderilen ve gelen E-Dönüşüm dokümanları için raporlama yapıldı ve müşteriye excel olarak sunuldu.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                            date="01.06.2018-30.09.2018"
                        >
                            <h3 className="vertical-timeline-element-title">V1.7 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">E-Döviz, Pdf/Html</h4>
                            <p>
                                Gönderilen ve gelen E-Dönüşüm dokümanları için pdf/html çıktısı eklendi.
                                E-Döviz dokümanları için listeleme sayfasının eklendi.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                            date="01.02.2018-30.05.2018"
                        >
                            <h3 className="vertical-timeline-element-title">V1.6 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">E-Dönüşüm arama,filtreleme ve Bug fix</h4>
                            <p>
                                Gönderilen ve gelen E-Dönüşüm dokümanları için filtreleme yapabileceği bir listeleme sayfası oldu.
                                Cari oluştururken unvan alanının uzun olmasından kaynaklı hata  giderildi.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            iconStyle={{ background: 'rgb(204,157,16)', color: '#fff' }}
                            date="01.10.2017-30.01.2018"
                        >
                            <h3 className="vertical-timeline-element-title">V1.5 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">Yabancı müşteri seçeneği</h4>
                            <p>
                                Müşteri e-imzası/mali mührü ile elektronik ortamda sözleşme imzalanabiliyor.
                                İhracat faturaları için aynı VKN/TCKN ye sahip birden fazla cari tanımlanabilmesi için yabancı müşteri seçeneğini eklendi.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            iconStyle={{ background: 'rgb(204,157,16)', color: '#fff' }}

                            date="01.07.2017-30.09.2017"
                        >
                            <h3 className="vertical-timeline-element-title">V1.4 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">Cari sayfası</h4>
                            <p>
                                Yeni cari kaydı oluşturuldu.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            iconStyle={{ background: 'rgb(204,157,16)', color: '#fff' }}
                            date="01.03.2017-30.06.2017"
                        >
                            <h3 className="vertical-timeline-element-title">V1.3 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">Portal geliştirmesi.</h4>
                            <p>
                                Yeni ürün kaydı girildi.
                                Müşterilerin bağlanacağı portal sayfasının sorunsuz ve kesintisiz çalışması için gerekli altyapı oluşturuldu.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            iconStyle={{ background: 'rgb(204,157,16)', color: '#fff' }}
                            date="01.11.2016-28.02.2017"
                        >
                            <h3 className="vertical-timeline-element-title">V1.2 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">E-Dönüşüm taslak sayfaları</h4>
                            <p>
                                Yeni taslak doküman (fatura, irsaliye, vb) oluşturuldu.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            iconStyle={{ background: 'rgb(204,16,82)', color: '#fff' }}
                            date="01.07.2016-30.10.2016"
                        >
                            <h3 className="vertical-timeline-element-title">V1.1 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">Müşteri sayfası</h4>
                            <p>
                                Yeni müşteri kaydı olmalıdır. Yeni kayıt oluşturuldu.
                            </p>
                        </VerticalTimelineElement>
                        <VerticalTimelineElement
                            className="vertical-timeline-element--education"
                            iconStyle={{ background: 'rgb(204,16,82)', color: '#fff' }}
                            date="01.03.2016-30.06.2016"
                        >
                            <h3 className="vertical-timeline-element-title">V1.0 Sürüm güncellemesi</h3>
                            <h4 className="vertical-timeline-element-subtitle">Giriş sayfası</h4>
                            <p>
                                Yetkisiz kullanımı engellemek için kullanıcı adı ve şifre girişinin yapıldığı bir giriş sayfası yapıldı.
                            </p>
                        </VerticalTimelineElement>
                    </VerticalTimeline>
                </div>


            </div>
        )
    }

}export default VersionTrack;